import { ReportingContainerBaseConfig, ReportingControllerBaseConfig } from '../../base';
import { MentionSpanController } from './mentionSpanInterface';
import { MentionSpanViewProps } from './mentionSpanProps';

export function createMentionSpanController(
    config: ReportingControllerBaseConfig
): MentionSpanController {
    return {
        useProps(context, item, props): MentionSpanViewProps {
            if (item.content.status === 'loading') {
                return {
                    status: 'loading',
                };
            }
            return {
                status: 'success',
                id: item.content.data.id,
                label: item.content.data.title,
                icon: item.content.data.icon
                    ? {
                          kind: 'emoji',
                          text: item.content.data.icon,
                      }
                    : null,
                link: item.content.data.collection
                    ? {
                          to: `?record=${item.content.data.id}`,
                      }
                    : {
                          to: `../${item.content.data.id}`,
                      },
                preview: {
                    content: item.content.data.id,
                },
            };
        },
    };
}
